var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm._f("datetime")(_vm.time,"ddd", _vm.timezone))+" "+_vm._s(_vm._f("dayschedule")(_vm.day)))])
}
var staticRenderFns = []

export { render, staticRenderFns }